import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=78837d0b&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=78837d0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78837d0b",
  null
  
)

export default component.exports